const PARTICLES = Array.from({ length: 18 }, (_, index) => ({
  x: (index * 37 + 11) % 100,
  y: (index * 53 + 7) % 100,
  size: 2 + (index % 4),
  delay: -(index % 9) * 0.7,
}));

export const InvestorVfx = ({ active, enabled, reducedMotion }) => (
  <div
    className={`invest-vfx ${enabled ? "is-enabled" : "is-muted"} ${reducedMotion ? "is-static" : ""}`}
    style={{ "--scene-phase": `${active * 29}deg`, "--scene-shift": `${(active % 5) * 7}%` }}
    aria-hidden="true"
    data-testid="invest-vfx-layer"
  >
    <div className="invest-vfx-mesh" />
    <div className="invest-vfx-ring" />
    <div className="invest-vfx-beam" />
    <div className="invest-vfx-particles">
      {PARTICLES.map((particle, index) => (
        <i
          key={index}
          style={{
            "--particle-x": `${particle.x}%`,
            "--particle-y": `${particle.y}%`,
            "--particle-size": `${particle.size}px`,
            "--particle-delay": `${particle.delay}s`,
          }}
        />
      ))}
    </div>
  </div>
);